export class ScrapQuantitySpec {
  public factor = 0.0
}
